// The frame a TV wallboard is laid out on (the window's shape, at least 1920 x 1080, made smaller by WALLBOARD_ZOOM so
// everything in it draws larger) and the scale that fits it to the screen.
export const WALLBOARD_WIDTH = 1920;
export const WALLBOARD_HEIGHT = 1080;
export const WALLBOARD_ZOOM = 1.15;
// keep equal to $frame-vh in Wallboard.scss and Reports.scss
export const WALLBOARD_FRAME_VH = WALLBOARD_HEIGHT / 100;
// keep equal to $tv-text in Wallboard.scss
export const WALLBOARD_TEXT_SIZE = '16px';

export function getWallboardFrame(width, height) {
  const scale = Math.min(width / WALLBOARD_WIDTH, height / WALLBOARD_HEIGHT) * WALLBOARD_ZOOM;
  return {
    scale,
    width: width / scale,
    height: height / scale
  };
}
